import { InjectionToken, Provider } from '@angular/core';
import { ActionReducer, ActionReducerMap, MetaReducer, combineReducers } from '@ngrx/store';
import { LoginLogoutActionTypes } from '../../../../../core/auth/user-auth/store/actions/login-logout.action';
import { Cart } from '../../../../../core/model';
import { CurrenciesActionTypes } from '../../../../../core/site-context/store/actions/currencies.action';
import { LanguagesActionTypes } from '../../../../../core/site-context/store/actions/languages.action';
import { PyStateUtils } from '../../../../../core/state';
import { SoldToActions } from '../../../../sold-to-base/store/actions';
import { CART, CUTTING_PRICE, CUTTING_TEMPLATE, CartState, REEL_CUTTING_PRICE, TINY_CART } from '../cart-state';
import { accountingCodesReducer } from './cart-accounting-codes.reducer';
import { activeReducer, cartReducer } from './cart.reducer';
import { reducer as cuttingTemplateReducer } from './cutting-template.reducer';
import { reducer as cuttingReducer } from './cutting.reducer';
import { prePrintedLabelReducer } from './pre-printed-label.reducer';
import { reducer as reelCuttingReducer } from './reel-cutting.reducer';
import { reducer as tinyCartReducer } from './tiny-cart.reducer';

export function getReducers(): ActionReducerMap<CartState, any> {
  return {
    tinyCarts: PyStateUtils.loaderReducer(TINY_CART, tinyCartReducer),
    carts: PyStateUtils.entityProcessesLoaderReducer<Cart>(CART, cartReducer),
    active: activeReducer,
    cutting: combineReducers({
      prices: PyStateUtils.entityLoaderReducer(CUTTING_PRICE, cuttingReducer),
      templates: PyStateUtils.entityLoaderReducer(CUTTING_TEMPLATE, cuttingTemplateReducer),
    }),
    reelCutting: combineReducers({
      prices: PyStateUtils.entityLoaderReducer(REEL_CUTTING_PRICE, reelCuttingReducer),
    }),
    accountingCodes: accountingCodesReducer,
    prePrintedLabels: prePrintedLabelReducer,
  };
}

export const reducerToken = new InjectionToken<ActionReducerMap<CartState>>('CartReducers');

export const reducerProvider: Provider = {
  provide: reducerToken,
  useFactory: getReducers,
};

export function clearCartState(reducer: ActionReducer<any>): ActionReducer<any> {
  return function (state, action) {
    if (action.type === LoginLogoutActionTypes.Logout) {
      state = undefined;
    }
    if (action.type === CurrenciesActionTypes.CurrencyChange || action.type === LanguagesActionTypes.LanguageChange) {
      state = undefined;
    }
    if (action.type === SoldToActions.ChangeSoldToActionTypes.ChangeSoldToSuccess) {
      state = undefined;
    }

    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<any>[] = [clearCartState];
